import { Link } from 'react-router-dom';
import { 
  Play, 
  Coffee, 
  Brain, 
  TestTube
} from 'lucide-react';

interface LearnPathMegaMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const LearnPathMegaMenu = ({ isOpen, onClose }: LearnPathMegaMenuProps) => {
  if (!isOpen) return null;

  return (
    <div className="absolute top-full right-0 pt-2 w-72 z-50">
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden animate-slide-down">
      <div className="py-2">
        {/* Automation Testing Section */}
        <div className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wide border-b border-gray-100">
          Automation Testing
        </div>
        
        <Link
          to="/paths/selenium-csharp"
          onClick={onClose}
          className="flex items-center gap-3 px-3 py-3 hover:bg-gray-50 transition-colors group"
        >
          <div className="p-1.5 bg-green-100 rounded-lg group-hover:bg-green-200 transition-colors">
            <TestTube className="w-4 h-4 text-green-600" aria-label="TestTube icon" />
          </div>
          <div className="flex-1">
            <div className="font-medium text-gray-900 text-sm">Selenium C# Mastery</div>
            <div className="text-xs text-gray-500">67,800+ students • Most Popular</div>
          </div>
        </Link>
        
        <Link
          to="/paths/selenium-java"
          onClick={onClose}
          className="flex items-center gap-3 px-3 py-3 hover:bg-gray-50 transition-colors group"
        >
          <div className="p-1.5 bg-orange-100 rounded-lg group-hover:bg-orange-200 transition-colors">
            <Coffee className="w-4 h-4 text-orange-600" aria-label="Coffee icon" />
          </div>
          <div className="flex-1">
            <div className="font-medium text-gray-900 text-sm">Selenium Java Mastery</div>
            <div className="text-xs text-gray-500">78,400+ students • Highest Enrolled</div>
          </div>
        </Link>
        
        <Link
          to="/paths/playwright"
          onClick={onClose}
          className="flex items-center gap-3 px-3 py-3 hover:bg-gray-50 transition-colors group"
        >
          <div className="p-1.5 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
            <Play className="w-4 h-4 text-blue-600" aria-label="Play icon" />
          </div>
          <div className="flex-1">
            <div className="font-medium text-gray-900 text-sm">Playwright Mastery</div>
            <div className="text-xs text-gray-500">54,200+ students • New This Month</div>
          </div>
        </Link>

        {/* AI & Machine Learning Section */}
        <div className="border-t border-gray-100">
          <div className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wide">
            AI & Machine Learning
          </div>
          
          <Link
            to="/paths"
            onClick={onClose}
            className="flex items-center gap-3 px-3 py-3 hover:bg-gray-50 transition-colors group"
          >
            <div className="p-1.5 bg-purple-100 rounded-lg group-hover:bg-purple-200 transition-colors">
              <Brain className="w-4 h-4 text-purple-600" aria-label="Brain icon" />
            </div>
            <div className="flex-1">
              <div className="font-medium text-gray-900 text-sm">AI & Testing Learning Path</div>
              <div className="text-xs text-gray-500">43,800+ students • Complete Journey</div>
            </div>
          </Link>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 p-2">
          <Link
            to="/paths"
            onClick={onClose}
            className="block w-full text-center px-4 py-2.5 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg text-sm font-medium hover:from-purple-700 hover:to-blue-700 transition-all duration-200"
          >
            View All Learning Paths
          </Link>
        </div>
      </div>
      </div>
    </div>
  );
};

export default LearnPathMegaMenu;